import script from "./ForbiddenView.vue?vue&type=script&setup=true&lang=js"
export * from "./ForbiddenView.vue?vue&type=script&setup=true&lang=js"

import "./ForbiddenView.vue?vue&type=style&index=0&id=3da0e863&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3da0e863"]])

export default __exports__